import { memo } from 'react';
import Image from 'next/image';

import { Container, NextLink } from '@/atoms';

import { FacadeSearchBoxDesktop } from '@/components/algolia';
import { InitPropsProvider } from '@/components/providers/initPropsProvider';
import { imageTransformer } from '@/lib/graphql/transformers';
import { routes } from '@/lib/routes';
import Toolbar from '../Toolbar';

import type { TypeImageGraphQL } from '@/lib/graphql/types';
import type { FunctionComponent } from 'react';
import type { PreHeaderProps } from './types';

/**
 * Primary UI component for user interaction
 */
const PreHeader: FunctionComponent<PreHeaderProps> = ({
  setLoginModalOpen,
  setOpen,
}: PreHeaderProps) => (
  <Container
    zIndex={100}
    wrapper
    padding="p-0 py-3 lg:pb-0"
    className="z-50 hidden lg:block"
  >
    <div className="u-body u-body--xs grid grid-cols-[1fr,_196px,_1fr] items-end gap-5">
      <FacadeSearchBoxDesktop placeholder="Busca productos aquí ..." />

      {/* Logo */}
      <InitPropsProvider.Consumer>
        {({
          options: {
            ajustesGenerales: { logo },
          },
        }) => {
          const logoImage = imageTransformer(logo as TypeImageGraphQL);

          return logo ? (
            <NextLink href={routes.index}>
              <a className="relative z-[4] mx-auto block">
                <span className="sr-only">BIGCRAFTERS</span>

                <Image
                  src={logoImage.src}
                  alt={logoImage.alt}
                  objectFit="contain"
                  objectPosition="center"
                  draggable="false"
                  priority={true}
                  width={192}
                  height={56}
                />
              </a>
            </NextLink>
          ) : null;
        }}
      </InitPropsProvider.Consumer>

      <div className="border-b border-b-primary-200 pb-4">
        <Toolbar setLoginModalOpen={setLoginModalOpen} setMenuOpen={setOpen} />
      </div>
    </div>
  </Container>
);

PreHeader.displayName = 'PreHeader';

export default memo(PreHeader);
